var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsGoToConsole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.923096H25V22.0769H0V0.923096ZM1.92307 4.76925V20.1539H23.0769V4.76925H1.92307ZM3.84615 7.65387H6.73077L9.61537 11.5L6.73077 15.3462H3.84615L6.73077 11.5L3.84615 7.65387Z",
    fill: "#0C6CDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsGoToConsole);
export default __webpack_public_path__ + "static/media/projects_goToConsole.e439a7ebcb45a0fbdd863f8de2fa85aa.svg";
export { ForwardRef as ReactComponent };